export const isUserInRole = (userRoles, role) => {
    return userRoles && userRoles.indexOf(role) > -1 ? true : false;
}